import React, { useState } from 'react'
import { Form, useFormikContext } from 'formik'
import classes from './style.module.scss'
import useStyles from 'isomorphic-style-loader/useStyles'
import { FormattedMessage } from 'react-intl'
import { IMAGE_GEEKO_LTD } from '../../../../../constants'


const PrivacyPart = props => {
    useStyles(classes)
    const {privacyPic, privacyInfo} = props

    return <div className={classes.PrivacyPartBox}>
        <div className={classes.PrivacyTitle}>
            <img src={`${IMAGE_GEEKO_LTD}/chicme/20230914024920994622.png`} alt="" />
            <span><FormattedMessage id="security_privacy" defaultMessage={'Security & Privacy'}/></span>
        </div>

        <div className={classes.PrivacyPic}>
            {privacyPic && <img src={privacyPic} alt="" />}

            <span className={classes.PrivacyInfo}>{privacyInfo}</span>
        </div>
    </div>
}

export default PrivacyPart